export const reviews = [
  {
    id: 1,
    name: "김OO",
    location: "서울 강남",
    rating: 5,
    date: "2025년 3월",
    text: "부모님 모시고 갔는데 일본어 하나도 못해도 너무 편했어요. 호스트분이 카카오톡으로 맛집도 추천해주시고 응급상황에서 병원까지 연결해 주셨어요. 다음 번에도 꼭 이 숙소 예약할 거예요!",
    avatar: "https://public.readdy.ai/ai/img_res/d5b597e81d069c5d351114118d78cfdd.jpg",
    accommodation: "하카타 럭셔리 패밀리 아파트",
  },
  {
    id: 2,
    name: "박OO",
    location: "부산 해운대",
    rating: 5,
    date: "2025년 1월",
    text: "솔직히 일본 여행 처음이라 무서웠는데, 한국어로 체크인부터 퇴실까지 모두 안내해 주셔서 너무 든든했어요. 야타이 포장마차 위치도 직접 지도 보내주셨고, 진짜 현지 정보 너무 좋았습니다!",
    avatar: "https://readdy.ai/api/search-image?query=Studio%20Ghibli%20anime%20illustration%20portrait%20of%20a%20confident%20young%20Korean%20man%20with%20neat%20black%20hair%20wearing%20a%20casual%20navy%20jacket%20warm%20smile%20light%20sky%20blue%20background%20soft%20watercolor%20illustration%20style&width=100&height=100&seq=2022&orientation=squarish",
    accommodation: "나카스 리버뷰 로맨틱 룸",
  },
  {
    id: 3,
    name: "이OO",
    location: "대구",
    rating: 5,
    date: "2024년 12월",
    text: "호스트 언니가 한국 분이라 정말 편했고, 텐진 주변 쇼핑 정보부터 면세 꿀팁까지 다 알려주셨어요. 숙소도 너무 깨끗하고 사진보다 훨씬 좋았어요. 완전 강추합니다!",
    avatar: "https://readdy.ai/api/search-image?query=Studio%20Ghibli%20anime%20illustration%20portrait%20of%20a%20bright%20cheerful%20young%20Korean%20woman%20long%20wavy%20dark%20hair%20wearing%20a%20mint%20green%20blouse%20pastel%20mint%20background%20big%20sparkling%20eyes%20watercolor%20style%20warm%20light&width=100&height=100&seq=2033&orientation=squarish",
    accommodation: "텐진 감성 한옥 스튜디오",
  },
  {
    id: 4,
    name: "최OO",
    location: "인천",
    rating: 5,
    date: "2025년 2월",
    text: "5살, 8살 아이 데리고 갔는데 호스트분이 유모차도 빌려주시고 아이 친화 식당 리스트도 만들어주셨어요. 덕분에 10년만의 가족여행이 완벽했어요. 감동 그 자체였어요!",
    avatar: "https://readdy.ai/api/search-image?query=Studio%20Ghibli%20anime%20illustration%20portrait%20of%20a%20kind%20warm%20Korean%20woman%20in%20her%2040s%20with%20tied-up%20dark%20hair%20wearing%20a%20soft%20rose%20blouse%20gentle%20motherly%20smile%20lavender%20pastel%20background%20watercolor%20style&width=100&height=100&seq=2044&orientation=squarish",
    accommodation: "오호리 공원 뷰 모던 하우스",
  },
  {
    id: 5,
    name: "정OO",
    location: "광주",
    rating: 5,
    date: "2025년 3월",
    text: "야간에 갑자기 약이 필요했는데, 밤 11시에 카카오톡 연락드렸더니 바로 응답 주시고 근처 약국 위치와 일본어 메모까지 보내주셨어요. 진짜 감사했습니다. 안심 여행 완성!",
    avatar: "https://readdy.ai/api/search-image?query=Studio%20Ghibli%20anime%20illustration%20portrait%20of%20a%20thoughtful%20Korean%20man%20in%20his%2030s%20with%20round%20glasses%20slightly%20messy%20hair%20wearing%20an%20olive%20green%20shirt%20calm%20expression%20warm%20amber%20background%20watercolor%20style&width=100&height=100&seq=2055&orientation=squarish",
    accommodation: "야쿠인 카페 거리 빈티지 룸",
  },
];
